import { render, staticRenderFns } from "./GutenbergHomeDisclaimer.vue?vue&type=template&id=8b120430&scoped=true&"
import script from "./GutenbergHomeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./GutenbergHomeDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./GutenbergHomeDisclaimer.vue?vue&type=style&index=0&id=8b120430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b120430",
  null
  
)

export default component.exports